// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuItemWarningIcon_menu-item-warning__j8EFQ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.MenuItemWarningIcon_menu-item-warning__icon__VqdPD {
  font-size: 1.1rem;
  color: #F59E0B;
  transition: transform 0.2s ease-in-out;
}
.MenuItemWarningIcon_menu-item-warning__j8EFQ:hover .MenuItemWarningIcon_menu-item-warning__icon__VqdPD {
  transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/MenuItemWarningIcon/MenuItemWarningIcon.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACF;AACE;EACE,iBAAA;EACA,cAAA;EACA,sCAAA;AACJ;AAGI;EACE,qBAAA;AADN","sourcesContent":[".menu-item-warning {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto; \n\n  &__icon {\n    font-size: 1.1rem;\n    color: #F59E0B; \n    transition: transform 0.2s ease-in-out;\n  }\n\n  &:hover {\n    .menu-item-warning__icon {\n      transform: scale(1.1);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu-item-warning": `MenuItemWarningIcon_menu-item-warning__j8EFQ`,
	"menu-item-warning__icon": `MenuItemWarningIcon_menu-item-warning__icon__VqdPD`
};
export default ___CSS_LOADER_EXPORT___;
